import script from "./SubscriptionButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionButton.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionButton.vue?vue&type=style&index=0&id=428be5fc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-428be5fc"]])

export default __exports__